import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import { IconTypes } from 'components/Icons';

export const LearnMoreAboutActivityGroup: FC = () => {
  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="activity_group"
      headerTitle="Activity Group"
      iconType={IconTypes.Documents}
      body={
        <Stack spacing={10}>
          <Text>
            Activity Group provides a way to simplify how you monitor activity
            in data sources. You can aggregate resources that you need to
            monitor for activity based on business context. It provides a
            criteria-based framework to mark resources for which you require
            deeper insights regarding activity, anomalies or malicious activity.
          </Text>
          <Text>
            When you create an Activity Group, Ariksa automatically prioritizes
            processing of activity related to every data source in it based on
            the criteria associated with each resource.
          </Text>
        </Stack>
      }
    />
  );
};
